import React from "react"
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";
import './style.scss'

export default function GoBackButton({
    onClickFunction
}) {
    const { t } = useTranslation("finance");
    return (
        <div onClick={() => onClickFunction()} className="goBackButton d-flex  mt-4"> 
          <Icon name="left arrow" size="small"/>
          <p className="goBackButtonText">{t("common.back")}</p>
        </div>
    );
}